import React from 'react';
import { motion } from 'framer-motion';
export function SignalFlow({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full h-full ${className}`} data-id="element-192">
      <svg viewBox="0 0 200 300" className="w-full h-full opacity-40" data-id="element-193">
        <g stroke="#0066ff" strokeWidth="1.5" fill="none" strokeOpacity="0.4" data-id="element-194">
          <path id="path1" d="M20 280 C 20 200, 180 150, 180 20" data-id="element-195" />
          <path id="path2" d="M60 280 C 60 180, 140 120, 140 20" data-id="element-196" />
          <path id="path3" d="M100 280 C 100 150, 100 100, 100 20" data-id="element-197" />
        </g>

        {/* Flowing Dots */}
        <motion.circle r="3" fill="#00e5ff" className="shadow-[0_0_8px_#00e5ff]" data-id="element-198">
          <animateMotion dur="3s" repeatCount="indefinite" path="M20 280 C 20 200, 180 150, 180 20" data-id="element-199" />
        </motion.circle>

        <motion.circle r="2" fill="#fff" data-id="element-200">
          <animateMotion dur="4s" repeatCount="indefinite" path="M60 280 C 60 180, 140 120, 140 20" begin="1s" data-id="element-201" />
        </motion.circle>

        <motion.circle r="3" fill="#00e5ff" data-id="element-202">
          <animateMotion dur="2.5s" repeatCount="indefinite" path="M100 280 C 100 150, 100 100, 100 20" begin="0.5s" data-id="element-203" />
        </motion.circle>
      </svg>
    </div>;
}